// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2SasM","amount":"Amount_amount__1SgdB","tip":"Amount_tip__1q_5o","tipHeader":"Amount_tipHeader__3VKAs","tipsWrap":"Amount_tipsWrap__mIVRg"};